/**
 * RiderTypeSection Component
 * 라이더 유형 섹션 (본사 사용자 전용)
 */
import React from 'react';
import { RiderType } from '../types/riderInfoDetail.types';

interface RiderTypeSectionProps {
    riderTypes: RiderType[];
    selectedRiderType: string;
    riderTypeLoading: boolean;
    onRiderTypeChange: (value: string) => void;
    onSave: () => void;
}

const RiderTypeSection: React.FC<RiderTypeSectionProps> = ({
    riderTypes,
    selectedRiderType,
    riderTypeLoading,
    onRiderTypeChange,
    onSave
}) => {
    return (
        <div className="section-margin">
            <h3 className="section-title">라이더 유형</h3>
            <div className="rider-type-section">
                <div className="rider-type-field">
                    <label htmlFor="riderTypeSelect" className="rider-type-label">
                        유 형 :
                    </label>
                    <select
                        id="riderTypeSelect"
                        className="form-input"
                        value={selectedRiderType}
                        onChange={(e) => onRiderTypeChange(e.target.value)}
                        disabled={riderTypeLoading}
                    >
                        <option value="">선택하세요</option>
                        {riderTypes.map((type) => (
                            <option key={type.code} value={type.code}>
                                {type.name}
                            </option>
                        ))}
                    </select>
                    <button
                        className="account-save-button rider-type-save-button"
                        type="button"
                        onClick={onSave}
                        disabled={!selectedRiderType || riderTypeLoading}
                    >
                        저장
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RiderTypeSection;
